<template>
  <div class="container">
    <h1>Editace uživatelů</h1>
  </div>
</template>

<script>
export default {
  name: "AdminUsersView"
}
</script>

<style scoped>
</style>